import { render, staticRenderFns } from "./MapSvg85.vue?vue&type=template&id=01bcc902"
import script from "./MapSvg85.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapSvg85.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports